enum EPaymentLinkStatus {
  NOT_PAID = 'not paid',
  PAID = 'paid',
  DELETED = 'deleted',
}

export default EPaymentLinkStatus;
